import React from 'react';
import DatePicker from 'react-datepicker';
import Panel from '../../../common/layout/Panel'
import { useParams } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { getList } from '../../../common/v4/BackendProvider';
import Table from '../../../common/Table';

const Summary = (props) => {
    const { account_id } = useParams();
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const today = new Date();
    const [d1, setD1] = useState(new Date(today.getFullYear(), today.getMonth() - 1, 1, 0, 0, 0));
    const [d2, setD2] = useState(new Date(today.getFullYear(), today.getMonth(), 0, 23, 59, 59));

    const fetchData = () => {
        setLoading(true);
        getList(`/admin/clients/clients/${account_id}/summary`, [
            {key: 'search', value: ''},
            {key: 'start_time_from', value: d1.toISOString()},
            {key: 'start_time_to', value: d2.toISOString()},
        ]).then(result => {
            setData(result.data.data);
        })
        .catch(error => console.error('Error:', error))
        .finally(() => setLoading(false));
    };

    useEffect(() => {
        fetchData();
    }, []);

    console.log(data);
    const columnsMT = [
        {
            label: 'Date',
            source: 'ATRDATE',
            type: 'text',
        },
        {
            label: 'Destination',
            source: 'DESTINATION',
            type: 'text'
        },
        {
            label: 'MT Count',
            source: 'MESSAGES_COUNT',
            type: 'text'
        },
        {
            label: 'MT Part Count',
            source: 'MESSAGES_PARTS_COUNT',
            type: 'text'
        },
        {
            label: 'Sell Amount',
            source: 'SELL_AMOUNT',
            type: 'money2'
        },
        {
            label: 'Sell Currency',
            source: 'SELL_CURRENCY_NAME',
            type: 'text'
        }
    ]

    const columnsMO = [
        {
            label: 'Date',
            source: 'ATRDATE',
            type: 'text',
        },
        {
            label: 'Destination',
            source: 'DESTINATION',
            type: 'text'
        },
        {
            label: 'MO Count',
            source: 'MESSAGES_COUNT',
            type: 'text'
        },
        {
            label: 'MO Part Count',
            source: 'MESSAGES_PARTS_COUNT',
            type: 'text'
        },
        {
            label: 'Sell Amount',
            source: 'SELL_AMOUNT',
            type: 'money2'
        },
        {
            label: 'Sell Currency',
            source: 'SELL_CURRENCY',
            type: 'select'
        }
    ]
    const columnsNumbers = [
        {
            label: 'Country',
            source: 'country',
            type: 'text'
        },
        {
            label: 'Capabilities',
            source: 'capabilities',
            type: 'text'
        },
        {
            label: 'Count',
            source: 'count',
            type: 'text'
        },
        {
            label: 'Amount',
            source: 'fees',
            type: 'money2'
        }
    ]
    const handleDateRangeFromChange = (value) => {
        setD1(value);
    }
    const handleDateRangeToChange = (value) => {
        setD2(value);
    }
    const handleSearch = () => {
        fetchData();
    }
    return (
        <div>
           <Panel title = "Summary">
            <>
                <div className="row">
                    <div className="col-md-12 form-group">
                        <label className="col-sm-1 control-label">From</label>
                        <div className="col-sm-3">
                            <DatePicker
                                className="form-control datepicker"
                                selected={ d1 }
                                onChange={ handleDateRangeFromChange }
                                showTimeSelect
                                timeFormat="HH:mm"
                                dateFormat="yyyy-MM-dd HH:mm"
                            />
                        </div>
                        <label className="col-sm-1 control-label">To</label>
                        <div className="col-sm-3">
                            <DatePicker
                                className="form-control datepicker"
                                selected={ d2 }
                                onChange={ handleDateRangeToChange }
                                showTimeSelect
                                timeFormat="HH:mm"
                                dateFormat="yyyy-MM-dd HH:mm"
                            />
                        </div>
                        <div className="col-sm-1">
                            <button className="btn btn-primary" onClick={handleSearch}>Search</button>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <div className="btn-group" role="group" style={{marginBottom: '15px'}}>
                            <button 
                                type="button" 
                                className="btn btn-sm btn-outline-secondary"
                                style={{marginRight: '5px'}}
                                onClick={() => {
                                    const today = new Date();
                                    setD1(new Date(today.getFullYear(), today.getMonth() - 1, 1, 0, 0, 0));
                                    setD2(new Date(today.getFullYear(), today.getMonth(), 0, 23, 59, 59));
                                }}
                            >
                                Last Month
                            </button>
                            <button 
                                type="button" 
                                className="btn btn-sm btn-outline-secondary"
                                style={{marginRight: '5px'}}
                                onClick={() => {
                                    const today = new Date();
                                    setD1(new Date(today.getFullYear(), today.getMonth(), 1, 0, 0, 0));
                                    setD2(new Date(today.getFullYear(), today.getMonth() + 1, 0, 23, 59, 59));
                                }}
                            >
                                Current Month
                            </button>
                            <button 
                                type="button" 
                                className="btn btn-sm btn-outline-secondary"
                                style={{marginRight: '5px'}}
                                onClick={() => {
                                    const today = new Date();
                                    const yesterday = new Date(today);
                                    yesterday.setDate(today.getDate() - 1);
                                    setD1(new Date(yesterday.getFullYear(), yesterday.getMonth(), yesterday.getDate(), 0, 0, 0));
                                    setD2(new Date(yesterday.getFullYear(), yesterday.getMonth(), yesterday.getDate(), 23, 59, 59));
                                }}
                            >
                                Yesterday
                            </button>
                            <button 
                                type="button" 
                                className="btn btn-sm btn-outline-secondary"
                                onClick={() => {
                                    const today = new Date();
                                    setD1(new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0));
                                    setD2(new Date(today.getFullYear(), today.getMonth(), today.getDate(), 23, 59, 59));
                                }}
                            >
                                Today
                            </button>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <h4>MT Messages</h4>
                        <Table
                            data = {data.dataMT}
                            metadata = {columnsMT}
                            loading = {loading}
                            id = "mt-table"
                            totals = {[
                                { value: 'Total', align: 'left' },
                                { value: '', align: 'center' },
                                { value: data.dataMT?.reduce((acc, row) => acc + parseFloat(row.MESSAGES_COUNT || 0), 0), align: 'center' },
                                { value: data.dataMT?.reduce((acc, row) => acc + parseFloat(row.MESSAGES_PARTS_COUNT || 0), 0), align: 'center' },
                                { value: data.dataMT?.reduce((acc, row) => acc + parseFloat(row.SELL_AMOUNT || 0), 0).toFixed(2), align: 'right' },
                                { value: '', align: 'center' }
                            ]}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <h4>MO Messages</h4>
                        <Table
                            data = {data.dataMO}
                            metadata = {columnsMO}
                            loading = {loading}
                            id = "mo-table"
                            totals = {[
                                { value: 'Total', align: 'left' },
                                { value: '', align: 'center' },
                                { value: data.dataMO?.reduce((acc, row) => acc + parseFloat(row.MESSAGES_COUNT || 0), 0), align: 'center' },
                                { value: data.dataMO?.reduce((acc, row) => acc + parseFloat(row.MESSAGES_PARTS_COUNT || 0), 0), align: 'center' },
                                { value: data.dataMO?.reduce((acc, row) => acc + parseFloat(row.SELL_AMOUNT || 0), 0).toFixed(2), align: 'right' },
                                { value: '', align: 'center' }
                            ]}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <h4>Numbers</h4>
                        <Table
                            data = {data.dataNumbers}
                            metadata = {columnsNumbers}
                            loading = {loading}
                            id = "numbers-table"
                            totals = {[
                                { value: 'Total', align: 'left' },
                                { value: '', align: 'center' },
                                { value: data.dataNumbers?.reduce((acc, row) => acc + parseFloat(row.count || 0), 0), align: 'center' },
                                { value: data.dataNumbers?.reduce((acc, row) => acc + parseFloat(row.fees || 0), 0).toFixed(2), align: 'right' }
                            ]}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <div className="card" style={{border: '1px solid #ddd',backgroundColor: '#f8f9fa'}}>
                            <div className="card-body" style={{backgroundColor: '#f8f9fa', paddingLeft: '20px'}}>
                                <h5 className="card-title">Total</h5>
                                <p className="card-text">
                                    <strong>Total Amount:</strong> {(data.dataMT?.reduce((acc, row) => acc + parseFloat(row.SELL_AMOUNT), 0) + data.dataMO?.reduce((acc, row) => acc + parseFloat(row.SELL_AMOUNT), 0)).toFixed(2)}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </>
            </Panel>
        </div>
    )
}


export default Summary;